type SearchParamsLike = {
  get(name: string): string | null;
};

export function getCitizenJoinPrefill(searchParams: SearchParamsLike): {
  callId: string;
  inviteToken: string;
} {
  return {
    callId: searchParams.get('callId') || searchParams.get('room') || '',
    inviteToken: searchParams.get('inviteToken') || '',
  };
}

export function parseCitizenInviteInput(value: string): {
  callId?: string;
  inviteToken?: string;
} {
  const trimmed = value.trim();
  if (!trimmed) return {};

  const looksLikeUrl = /^https?:\/\//i.test(trimmed);
  const looksLikePath = trimmed.includes('/calls/') || trimmed.includes('/citizen') || trimmed.includes('inviteToken=');

  const candidate = looksLikeUrl
    ? trimmed
    : looksLikePath
      ? `https://placeholder.local/${trimmed.replace(/^\/+/, '')}`
      : null;

  if (!candidate) {
    return { callId: trimmed };
  }

  try {
    const url = new URL(candidate);
    const inviteToken = url.searchParams.get('inviteToken') || undefined;
    const callId = url.searchParams.get('callId') || url.searchParams.get('room') || undefined;
    const callMatch = url.pathname.match(/\/calls\/([^/]+)/i);
    const callFromPath = callMatch ? decodeURIComponent(callMatch[1]) : undefined;

    return {
      callId: callId || callFromPath,
      inviteToken,
    };
  } catch {
    return {};
  }
}
